import React, { Fragment, useState, useEffect } from 'react';
import { Container, TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, CardFooter } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import classnames from 'classnames';
import { toast } from 'react-toastify';
import { Send } from 'react-feather';
import { fetchFormData, fetchTableData, handleAddModifyOperation } from '../../../../Api/ApiMethods';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import PowerOfAttorneyInfo from './PowerOfAttorneyInfo';
import CustomerInfo from './CustomerInfo';
import ExpenseAndCollectionInfo from './ExpenseAndCollectionInfo';
import AccidentFileInfo from './AccidentFileInfo';
import LicensePlateInfo from './LicensePlateInfo';
import axios from 'axios';

const UserDetailForm = () => {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const isNew = location.state?.isNew || false;

    const [activeTab, setActiveTab] = useState('1');
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [powersOfAttorney, setPowersOfAttorney] = useState([]);
    const [insuranceCompanies, setInsuranceCompanies] = useState([]);
    const [licensePlates, setLicensePlates] = useState([]);
    const [accidentFiles, setAccidentFiles] = useState([]);
    const [expenses, setExpenses] = useState([]);
    const [paymentCollections, setPaymentCollections] = useState([]);
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedAccidentFiles, setSelectedAccidentFiles] = useState([]);
    const [selectedPowersOfAttorney, setSelectedPowersOfAttorney] = useState([]);
    const [selectedLicensePlates, setSelectedLicensePlates] = useState([]);
    
    const customerDetailApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/customer/${id}`;
    const licensePlateApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/licenseplate?customer=${id}`;
    const accidentFileApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/accidentfile?customer=${id}`;
    const expenseApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/expense?customer=${id}`;
    const paymentCollectionApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/paymentcollection?customer=${id}`;
    const cityApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/city';
    const districtApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/district?city=${selectedCity}`;
    const powerOfAttorneyApiUrl = `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/powerofattorney?customer=${id}`;
    const insuranceCompaniesApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/insurancecompany';

    const toggle = tab => {
        if (activeTab !== tab) {
            setSelectedAccidentFiles([]);
            setSelectedPowersOfAttorney([]);
            setSelectedLicensePlates([]);
            setActiveTab(tab);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchFormData({
                    apiEndpoint: customerDetailApiUrl,
                    page: 1,
                    pageSize: 1,
                });
                
                console.log('Customer API Response:', response);
                
                // Extract data based on API response structure
                let data;
                if (response?.isSuccess && response?.data) {
                    // New API format with isSuccess/data wrapper
                    data = response.data;
                } else if (response) {
                    // Old API format with direct data return
                    data = response;
                } else {
                    // No valid data
                    toast.error('Müşteri bilgileri alınamadı');
                    return;
                }
                
                if (data) {
                    // Safely access district and city properties
                    if (data.district?.city?.id) {
                        setSelectedCity(data.district.city.id);                        
                        try {
                            const districtsResponse = await fetchFormData({
                                apiEndpoint: `${process.env.REACT_APP_LACIVERT_API_ENDPOINT}/district?city=${data.district.city.id}`,
                                page: 1,
                                pageSize: 100
                            });
                            
                            // Handle both API response formats
                            let districtsData;
                            if (districtsResponse?.isSuccess && districtsResponse?.data) {
                                districtsData = districtsResponse.data;
                            } else {
                                districtsData = districtsResponse;
                            }
                            
                            if (districtsData?.items && Array.isArray(districtsData.items)) {
                                setDistricts(districtsData.items);
                            } else if (Array.isArray(districtsData)) {
                                setDistricts(districtsData);
                            }
                        } catch (error) {
                            console.error('Error fetching districts:', error);
                            toast.error('İlçeler alınırken hata oluştu.');
                        }
                    }

                    // Create formData with safe property access using optional chaining
                    const formData = {
                        customerType: data?.customerType || '',
                        reference: data?.reference || '', // Reference eklendi
                        agent: data?.agent || null, // Pass the entire agent object
                        agentName: data?.agent ? `${data.agent.firstName || ''} ${data.agent.lastName || ''}` : '',
                        clientName: data?.clientName || '',
                        companyName: data?.companyName || '',
                        identityNumber: data?.identityNumber || '',
                        taxNumber: data?.taxNumber || '',
                        crsNumber: data?.crsNumber || '',
                        contractRate: data?.contractRate?.toString() || '',
                        companyRepresentative: data?.companyRepresentative || '',
                        
                        // Safely access array elements with optional chaining
                        emailDescription: data?.emails && data.emails.length > 0
                            ? data.emails[0].emailDescription
                            : '',
                        email: data?.emails && data.emails.length > 0
                            ? data.emails[0].email
                            : '',
                        emailDescription2: data?.emails && data.emails.length > 1
                            ? data.emails[1].emailDescription
                            : '',
                        email2: data?.emails && data.emails.length > 1
                            ? data.emails[1].email
                            : '',
                        
                        ibanDescription: data?.ibans && data.ibans[0]?.ibanDescription || '',
                        iban: data?.ibans && data.ibans[0]?.iban || '',
                        ibanDescription2: data?.ibans && data.ibans[1]?.ibanDescription || '',
                        iban2: data?.ibans && data.ibans[1]?.iban || '',
                        
                        middleman: data?.middleman || '',
                        middlemanIban: data?.middlemanIban || '',
                        middlemanContractRate: data?.middlemanContractRate?.toString() || '',
                        isMiddlemanContractBased: data?.isMiddlemanContractBased || false,
                        middlemanContractPrice: data?.middlemanContractPrice?.toString() || '',
                        
                        phoneDescription: data?.phones && data.phones[0]?.phoneDescription || '',
                        phoneNumber: data?.phones && data.phones[0]?.phone || '',
                        phoneDescription2: data?.phones && data.phones[1]?.phoneDescription || '',
                        phoneNumber2: data?.phones && data.phones[1]?.phone || '',
                        
                        contractOriginalArrived: data?.contractOriginalArrived || false,
                        district: data?.district?.id || '',
                        address: data?.address || '',
                        comment: data?.comments && data.comments[0]?.comment || '',
                        created: data?.created ? new Date(data.created).toISOString().slice(0, 16) : '',
                    };
                    setFormData(formData);
                }
            } catch (error) {
                console.error('Error fetching customer details:', error);
                toast.error('Müşteri ayrıntıları alınırken hata oluştu.');
            }
        };
        if (!isNew) {
            fetchData();
        }
    }, [customerDetailApiUrl, isNew]);

    const fetchTabData = async () => {
        if (isNew || !id) return;
        try {
            if (activeTab === '2') {
                await fetchTableData({
                    apiEndpoint: powerOfAttorneyApiUrl,
                    page: 1,
                    pageSize: 10,
                    setDataCallback: (response) => {
                        // Handle API response formats
                        if (response?.isSuccess && response?.data?.items) {
                            setPowersOfAttorney(response.data.items);
                        } else if (response?.items) {
                            setPowersOfAttorney(response.items);
                        } else if (Array.isArray(response)) {
                            setPowersOfAttorney(response);
                        } else {
                            setPowersOfAttorney([]);
                        }
                    },
                    setTotalRowsCallback: () => { }
                });
            } else if (activeTab === '3') {
                await fetchTableData({
                    apiEndpoint: licensePlateApiUrl,
                    page: 1,
                    pageSize: 100,
                    setDataCallback: (response) => {
                        // Handle API response formats
                        if (response?.isSuccess && response?.data?.items) {
                            setLicensePlates(response.data.items);
                        } else if (response?.items) {
                            setLicensePlates(response.items);
                        } else if (Array.isArray(response)) {
                            setLicensePlates(response);
                        } else {
                            setLicensePlates([]);
                        }
                    },
                    setTotalRowsCallback: () => { }
                });
                
                // Fetch insurance companies for license plate form
                try {
                    const data = await fetchFormData({
                        apiEndpoint: insuranceCompaniesApiUrl,
                        page: 1,
                        pageSize: 100
                    });
                    
                    if (data?.isSuccess && data?.data?.items) {
                        setInsuranceCompanies(data.data.items);
                    } else if (data?.items) {
                        setInsuranceCompanies(data.items); 
                    } else if (Array.isArray(data)) {
                        setInsuranceCompanies(data);
                    } else {
                        setInsuranceCompanies([]);
                    }
                } catch (error) {
                    console.error('Error fetching insurance companies:', error);
                    toast.error('Sigorta şirketleri alınırken hata oluştu.');
                }
            } else if (activeTab === '4') {
                await fetchTableData({
                    apiEndpoint: accidentFileApiUrl,
                    page: 1,
                    pageSize: 10,
                    setDataCallback: (response) => {
                        // Handle API response formats
                        if (response?.isSuccess && response?.data?.items) {
                            setAccidentFiles(response.data.items);
                        } else if (response?.items) {
                            setAccidentFiles(response.items);
                        } else if (Array.isArray(response)) {
                            setAccidentFiles(response);
                        } else {
                            setAccidentFiles([]);
                        }
                    },
                    setTotalRowsCallback: () => { }
                });
            } else if (activeTab === '5') {
                await fetchTableData({
                    apiEndpoint: expenseApiUrl,
                    page: 1,
                    pageSize: 10,
                    setDataCallback: (response) => {
                        // Handle API response formats
                        if (response?.isSuccess && response?.data?.items) {
                            setExpenses(response.data.items);
                        } else if (response?.items) {
                            setExpenses(response.items);
                        } else if (Array.isArray(response)) {
                            setExpenses(response);
                        } else {
                            setExpenses([]);
                        }
                    },
                    setTotalRowsCallback: () => { }
                });
                
                await fetchTableData({
                    apiEndpoint: paymentCollectionApiUrl,
                    page: 1,
                    pageSize: 10,
                    setDataCallback: (response) => {
                        // Handle API response formats
                        if (response?.isSuccess && response?.data?.items) {
                            setPaymentCollections(response.data.items);
                        } else if (response?.items) {
                            setPaymentCollections(response.items);
                        } else if (Array.isArray(response)) {
                            setPaymentCollections(response);
                        } else {
                            setPaymentCollections([]);
                        }
                    },
                    setTotalRowsCallback: () => { }
                });
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
            toast.error('İlgili veriler çekilirken hata oluştu.');
        }
    };

    useEffect(() => {
        fetchTabData();
    }, [activeTab, id, isNew, licensePlateApiUrl, insuranceCompaniesApiUrl]);

    useEffect(() => {
        const fetchCities = async () => {
            try {
                const response = await fetchFormData({
                    apiEndpoint: cityApiUrl,
                    page: 1,
                    pageSize: 100
                });
                
                // Handle both API response formats
                if (response?.isSuccess && response?.data?.items) {
                    setCities(response.data.items);
                } else if (response?.items) {
                    setCities(response.items);
                } else if (Array.isArray(response)) {
                    setCities(response);
                } else {
                    setCities([]);
                }
            } catch (error) {
                console.error('Error fetching cities:', error);
                toast.error('Şehirler alınırken hata oluştu.');
            }
        };
        fetchCities();
    }, []);

    useEffect(() => {
        const fetchDistricts = async () => {
            if (selectedCity) {
                try {
                    const response = await fetchFormData({
                        apiEndpoint: districtApiUrl,
                        page: 1,
                        pageSize: 100
                    });
                    
                    // Handle both API response formats
                    if (response?.isSuccess && response?.data?.items) {
                        setDistricts(response.data.items);
                    } else if (response?.items) {
                        setDistricts(response.items);
                    } else if (Array.isArray(response)) {
                        setDistricts(response);
                    } else {
                        setDistricts([]);
                    }
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    toast.error('İlçeler alınırken hata oluştu.');
                }
            } else {
                setDistricts([]);
            }
        };
        fetchDistricts();
    }, [selectedCity, districtApiUrl]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        let processedValue = type === 'checkbox' ? checked : value;

        // Büyük harfe çevrilecek alanlar (Türkçe karakter duyarlı)
        const fieldsToUppercase = [
            'clientName', 'companyName', 'identityNumber', 'taxNumber', 'crsNumber',
            'companyRepresentative',
            'emailDescription', 'emailDescription2',
            'ibanDescription', 'ibanDescription2',
            'middleman', 'middlemanIban',
            'phoneDescription', 'phoneDescription2',
            'address',
            'comment' // Yorumları da büyük harfe çevirmek isterseniz
        ];

        // IBAN gibi özel formatı olan veya sadece sayı/özel karakter içeren
        // alanları bu listeye eklemiyoruz. Onlar kendi kontrollerine sahip olabilir.
        // agentName gibi alanlar burada değil, çünkü direkt input'tan gelmiyor.

        // Eğer alan listedeyse VE değer bir string ise Türkçe'ye özgü büyük harfe çevir
        if (fieldsToUppercase.includes(name) && typeof value === 'string') {
            processedValue = value.toLocaleUpperCase('tr-TR');
        }
        // E-posta alanlarını küçük harfe çevir
        else if (name === 'email' || name === 'email2') {
            processedValue = value ? String(value).toLowerCase() : '';
        }
        // IBAN özel formatlama/uppercase kendi onChange'inde yapılabilir
        // Örnek: Eğer IBAN'ı da buradan handle etmek isterseniz:
        /*
        else if (name === 'iban' || name === 'iban2') {
             processedValue = value ? String(value).toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
             // Gerekirse boşluk ekleme vs. burada yapılabilir
        }
        */

        // Aracı Sözleşme Türü değişikliği için özel mantık
        let updatedFormData = {
            ...formData,
            [name]: processedValue,
        };

        // Aracı Sözleşme Türü seçimi değiştiğinde diğer alanı null yap
        if (name === 'isMiddlemanContractBased') {
            if (processedValue === true || processedValue === "true") {
                // Oran bazlı seçildiğinde fiyat alanını temizle
                updatedFormData.middlemanContractPrice = '';
            } else if (processedValue === false || processedValue === "false") {
                // Fiyat bazlı seçildiğinde oran alanını temizle
                updatedFormData.middlemanContractRate = '';
            }
        }

        setFormData(updatedFormData);

         // Hataları temizle (eğer varsa)
         if (errors[name]) {
             setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
         }
    };

    const handleCustomerTypeChange = (e) => {
        const newCustomerType = e.target.value;
        setFormData((prevFormData) => ({
            ...prevFormData,
            customerType: newCustomerType,
            clientName: newCustomerType === 'Bireysel' ? prevFormData.clientName : '',
            tcid: newCustomerType === 'Bireysel' ? prevFormData.tcid : '',
            companyName: newCustomerType === 'Kurumsal' ? prevFormData.companyName : '',
            crsNumber: newCustomerType === 'Kurumsal' ? prevFormData.crsNumber : '',
            taxNumber: newCustomerType === 'Kurumsal' ? prevFormData.taxNumber : '',
            companyRepresentative: newCustomerType === 'Kurumsal' ? prevFormData.companyRepresentative : '',
            email: newCustomerType === 'Kurumsal' ? prevFormData.email : '',
        }));
    };

    const handleSave = async () => {
        // Validate form before saving
        const validationErrors = validateForm(formData); // Hataları al
        // Hata varsa işlemi durdur
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors); // Hataları state'e set et (zaten validateForm içinde yapılıyor ama garanti olsun)
            toast.error('Lütfen formdaki hataları düzeltin.');
            return;
        }

        try {
            const payload = {
                customerType: formData.customerType,
                reference: formData.reference || '', // Reference string olarak eklendi
                // agent array olarak gönderiliyor, kontrol edelim
                agent: formData.agent?.id ? formData.agent.id : '',
                clientName: formData.clientName || '', // State'den al (zaten büyük harf)
                companyName: formData.companyName || '', // State'den al (zaten büyük harf)
                identityNumber: formData.identityNumber || '', // State'den al (zaten büyük harf)
                taxNumber: formData.taxNumber || '', // State'den al (zaten büyük harf)
                crsNumber: formData.crsNumber || '', // State'den al (zaten büyük harf)
                contractRate: formData.contractRate ? Number(formData.contractRate) : 0,
                companyRepresentative: formData.companyRepresentative || '', // State'den al (zaten büyük harf)
                emails: [
                    // Email state'den alınıyor (zaten küçük harf), açıklama state'den alınıyor (zaten büyük harf)
                    formData.email ? {
                        emailDescription: formData.emailDescription || 'Birincil E-posta',
                        email: formData.email
                    } : null,
                    formData.email2 ? {
                        emailDescription: formData.emailDescription2 || 'İkincil E-posta',
                        email: formData.email2
                    } : null
                ].filter(Boolean), // null olanları filtrele
                ibans: [
                     // IBAN state'den alınıyor, açıklama state'den alınıyor (zaten büyük harf)
                    formData.iban ? { ibanDescription: formData.ibanDescription || '', iban: formData.iban } : null,
                    formData.iban2 ? { ibanDescription: formData.ibanDescription2 || '', iban: formData.iban2 } : null
                ].filter(Boolean),
                middleman: formData.middleman || '', // State'den al (zaten büyük harf)
                middlemanIban: formData.middlemanIban || '', // State'den al (zaten büyük harf)
                middlemanContractRate: (formData.isMiddlemanContractBased === true || formData.isMiddlemanContractBased === "true") 
                    ? (formData.middlemanContractRate ? Number(formData.middlemanContractRate) : 0) 
                    : null,
                isMiddlemanContractBased: formData.isMiddlemanContractBased || false,
                middlemanContractPrice: (formData.isMiddlemanContractBased === false || formData.isMiddlemanContractBased === "false") 
                    ? (formData.middlemanContractPrice || null) 
                    : null,
                phones: [
                    // Telefon state'den alınıyor, açıklama state'den alınıyor (zaten büyük harf)
                    formData.phoneNumber ? { phoneDescription: formData.phoneDescription || '', phone: formData.phoneNumber } : null,
                    formData.phoneNumber2 ? { phoneDescription: formData.phoneDescription2 || '', phone: formData.phoneNumber2 } : null
                ].filter(Boolean),
                contractOriginalArrived: formData.contractOriginalArrived || false,
                 // district array olarak gönderiliyor, kontrol edelim
                district: formData.district ? formData.district : '',
                address: formData.address || '', // State'den al (zaten büyük harf)
                comments: formData.comment ? [{ commentType: null, comment: formData.comment }] : [] // State'den al (belki büyük harf)
            };


            // API çağrısı (isNew kontrolü ile)
            if (isNew) {
                const response = await axios.post(process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/customer', payload);
                if (response?.data?.isSuccess && response?.data?.data?.id) {
                    toast.success('Müşteri başarıyla oluşturuldu!');
                    navigate(`/customer/${response.data.data.id}`); // Yeni ID ile detay sayfasına yönlendir
                } else {
                     // Başarısız ama kontrollü hata durumu
                     toast.error(response?.data?.message || 'Müşteri oluşturulamadı.');
                }
            } else {
                // Mevcut müşteri güncelleme
                await handleAddModifyOperation({
                    apiEndpoint: process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/customer',
                    selectedItem: { id },
                    mode: 'modify',
                    data: payload,
                    refreshDataCallback: null, // Detay sayfasında tablo refresh'e gerek yok
                    componentName: 'Müşteri'
                });
                // Güncelleme sonrası toast mesajı handleAddModifyOperation içinde veriliyor olabilir,
                // veya burada ekstradan gösterilebilir.
                // toast.success('Müşteri başarıyla güncellendi!');
            }
        } catch (error) {
             // Genel API veya ağ hatası
            console.error("Müşteri kaydetme hatası:", error);
            toast.error('Müşteri kaydedilirken bir hata oluştu.');
        }
    };

    const handleAccidentFileRowSelection = (state) => {
        setSelectedAccidentFiles(state.selectedRows);
    };

    const validateForm = (formData) => {
        const newErrors = {};

        // Validate customer type specific fields
        if (formData.customerType === 'Bireysel') {
            if (!formData.clientName?.trim()) {
                newErrors.clientName = 'Müvekkil adı zorunludur';
            }
            // Büyük harf kontrolü kaldırıldı
            // else if (!/^[A-ZĞÜŞİÖÇ][a-zğüşıöçĞÜŞİÖÇ]+(?: [A-ZĞÜŞİÖÇ][a-zğüşıöçĞÜŞİÖÇ]+)+$/.test(formData.clientName)) {
            //     newErrors.clientName = 'Ad ve soyad büyük harfle başlamalı ve en az iki kelimeden oluşmalıdır';
            // }
            // İsteğe bağlı: Sadece harf ve boşluk kontrolü eklenebilir
            else if (!/^[A-ZĞÜŞİÖÇ\s]+$/i.test(formData.clientName)) {
                 newErrors.clientName = 'Müvekkil adı sadece harf ve boşluk içermelidir.';
            }


            if (!formData.identityNumber?.trim()) {
                newErrors.identityNumber = 'TC Kimlik Numarası zorunludur';
            } else if (!/^\d{11}$/.test(formData.identityNumber)) { // Sadece 11 rakam kontrolü
                newErrors.identityNumber = 'TC Kimlik Numarası 11 haneli rakam olmalıdır';
            }
        } else if (formData.customerType === 'Kurumsal') {
            if (!formData.companyName?.trim()) {
                newErrors.companyName = 'Şirket adı zorunludur';
            }
            if (!formData.crsNumber?.trim()) {
                newErrors.crsNumber = 'MERSIS numarası zorunludur';
            }
            if (!formData.taxNumber?.trim()) {
                newErrors.taxNumber = 'Vergi numarası zorunludur';
            }
            if (!formData.companyRepresentative?.trim()) {
                newErrors.companyRepresentative = 'Firma yetkilisi zorunludur';
            }
             // E-posta kontrolü aşağıda ortak alanda yapılıyor
        }

        // Validate common required fields
        if (!formData.phoneDescription?.trim()) {
            newErrors.phoneDescription = 'Telefon açıklaması zorunludur';
        }
        if (!formData.phoneNumber?.trim()) {
            newErrors.phoneNumber = 'Telefon numarası zorunludur';
        } else if (!/^\d{11}$/.test(formData.phoneNumber)) { // Sadece 11 rakam kontrolü
             // Başlangıç 05 kontrolü kaldırılabilir veya backend'de yapılabilir
            newErrors.phoneNumber = 'Telefon numarası 11 haneli rakam olmalıdır';
        }

        if (!formData.ibanDescription?.trim()) {
            newErrors.ibanDescription = 'İban açıklaması zorunludur';
        }
        if (!formData.iban?.trim()) {
            newErrors.iban = 'İban zorunludur';
        } else if (!/^[A-Z]{2}\d{2}[A-Z0-9]{1,}$/i.test(formData.iban.replace(/\s/g, ''))) { // Genel IBAN formatı (boşluksuz)
             // TR veya uzunluk kontrolü burada daha esnek olabilir, handleInputChange'da veya backend'de yapılabilir.
            newErrors.iban = 'Geçerli bir IBAN formatı giriniz (örn: TR12...)';
        }

        if (!selectedCity) { // selectedCity state'ini kontrol et
            newErrors.city = 'İl seçimi zorunludur';
        }
        if (!formData.district) { // formData.district'i kontrol et
            newErrors.district = 'İlçe seçimi zorunludur';
        }
        if (!formData.address?.trim()) {
            newErrors.address = 'Adres zorunludur';
        }

        // E-posta kontrolleri (Hem bireysel hem kurumsal için geçerli olabilir)
        if (formData.email && !formData.emailDescription?.trim()) {
            newErrors.emailDescription = 'E-mail açıklaması zorunludur';
        }
         if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
             newErrors.email = 'Geçerli bir e-mail adresi giriniz';
         }


        if (formData.email2 && !formData.emailDescription2?.trim()) {
            newErrors.emailDescription2 = 'E-mail 2 açıklaması zorunludur';
        }
         if (formData.email2 && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email2)) {
            newErrors.email2 = 'Geçerli bir e-mail 2 adresi giriniz';
        }

        // Kurumsal Müşteri için ek zorunluluklar
        if (formData.customerType === 'Kurumsal') {
             if (!formData.email?.trim()) { // Kurumsal için email zorunlu
                newErrors.email = 'E-mail zorunludur';
             }
             if (!formData.emailDescription?.trim()) { // Kurumsal için email açıklaması zorunlu
                newErrors.emailDescription = 'E-mail açıklaması zorunludur';
             }
        }


        setErrors(newErrors); // Hataları state'e ata
        return newErrors; // Hata nesnesini döndür
    };

    return (
        <Fragment>
            <Breadcrumbs parent='Müşteri Alanları' title={isNew ? 'Yeni Müşteri' : 'Müşteri Detayı'} />
            <Container fluid>
                <div className='edit-profile'>
                    <Card>
                        <Nav className='nav-primary nav-pills mb-4 mt-4 ms-4 d-flex gap-2'>
                            <NavItem>
                                <NavLink
                                    role="button"
                                    tabIndex="0"
                                    className={classnames({ active: activeTab === '1' })}
                                    onClick={() => { toggle('1'); }}
                                >
                                    Müşteri Bilgileri
                                </NavLink>
                            </NavItem>
                            {!isNew && (
                                <>
                                    <NavItem>
                                        <NavLink
                                            role="button"
                                            tabIndex="0"
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { toggle('2'); }}
                                        >
                                            Vekaletnameler
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            role="button"
                                            tabIndex="0"
                                            className={classnames({ active: activeTab === '3' })}
                                            onClick={() => { toggle('3'); }}
                                        >
                                            Plakalar
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            role="button"
                                            tabIndex="0"
                                            className={classnames({ active: activeTab === '4' })}
                                            onClick={() => { toggle('4'); }}
                                        >
                                            Kaza Dosyaları
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            role="button"
                                            tabIndex="0"
                                            className={classnames({ active: activeTab === '5' })}
                                            onClick={() => { toggle('5'); }}
                                        >
                                            Masraflar ve Tahsilatlar
                                        </NavLink>
                                    </NavItem>
                                </>
                            )}
                        </Nav>
                    </Card>
                    <Card>
                        <CardBody>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <CustomerInfo
                                        customerId={id}
                                        formData={formData}
                                        errors={errors}
                                        setErrors={setErrors}
                                        handleInputChange={handleInputChange}
                                        handleCustomerTypeChange={handleCustomerTypeChange}
                                        cities={cities}
                                        districts={districts}
                                        selectedCity={selectedCity}
                                        setSelectedCity={setSelectedCity}
                                    />
                                </TabPane>
                                {!isNew && (
                                    <>
                                        <TabPane tabId="2">
                                            <PowerOfAttorneyInfo
                                                powersOfAttorney={powersOfAttorney}
                                                onDataChange={() => {
                                                    fetchTabData();
                                                    setSelectedPowersOfAttorney([]);
                                                }}
                                                customerId={id}
                                                selectedRows={selectedPowersOfAttorney}
                                                onSelectedRowsChange={(state) => setSelectedPowersOfAttorney(state.selectedRows)}
                                            />
                                        </TabPane>
                                        <TabPane tabId="3">
                                            <LicensePlateInfo
                                                licensePlates={licensePlates}
                                                insuranceCompanies={insuranceCompanies}
                                                onDataChange={() => fetchTabData()}
                                                customerId={id}
                                            />
                                        </TabPane>
                                        <TabPane tabId="4">
                                            <AccidentFileInfo
                                                accidentFiles={accidentFiles}
                                                selectedRows={selectedAccidentFiles}
                                                onSelectedRowsChange={handleAccidentFileRowSelection}
                                            />
                                        </TabPane>
                                        <TabPane tabId="5">
                                            <ExpenseAndCollectionInfo
                                                expenses={expenses}
                                                paymentCollections={paymentCollections}
                                                onDataChange={() => fetchTabData()}
                                                customerId={id}
                                            />
                                        </TabPane>
                                    </>
                                )}
                            </TabContent>
                        </CardBody>
                        {activeTab === '1' && (
                            <CardFooter>
                                <div className="d-flex justify-content-end align-items-center w-100">
                                    <button className="btn btn-success d-flex align-items-center ms-2" onClick={handleSave}>
                                        <Send className="me-2" />
                                        {isNew ? 'Kaydet' : 'Güncelle'}
                                    </button>
                                </div>
                            </CardFooter>
                        )}
                    </Card>
                </div>
            </Container>
        </Fragment>
    );
};

export default UserDetailForm;
